<template>
  <div class="orderAi">
    <div class="headers">
      <span class="iconfont icon-back-left" @click="goBack" style="position: absolute;left: 20px"></span>
      {{lang.ailhdd}}</div>
    <div class="menuss">
      <div :class="['menu',orderStatus == 0 ?  'menu-active':'']" @click="selectMenu(0)">{{ lang.zc }}</div>
      <div :class="['menu',orderStatus == 1 ?  'menu-active':'']" @click="selectMenu(1)">{{ lang.yjs }}</div>
    </div>
    <div class="bodyoo">
      <div class="items">
        <van-list v-model="loading" :finished="finished" :finished-text="lang.mygdl" :loading-text="lang.jzz" @load="onLoad">
          <div class="new-features" v-for="item in recordList">
            <div class="title">{{item.ratioName}}</div>
          <div class="line">
            <div class="left">{{lang.amount}}</div>
            <div class="right">${{item.amt}}</div>
          </div>
          <div class="line">
            <div class="left">{{lang.term}}</div>
            <div class="right">{{ item.ratioName }}</div>
          </div>
          <div class="line">
            <div class="left">ROA</div>
            <div class="right">{{ item.minRatio }}-{{item.maxRatio}}%</div>
          </div>
          <div class="line">
            <div class="left">{{lang.todayBenefit}}</div>
            <div class="right">${{item.bonus}}</div>
          </div>
          <div class="line">
            <div class="left">{{lang.totalEarnings}}</div>
            <div class="right">${{item.bonus}}</div>
          </div>
          <div class="line">
            <div class="left">{{lang.OrderNumber}}</div>
            <div class="right">{{ item.ordno }}</div>
          </div>
          <div class="line">
            <div class="left">{{lang.GenerationTime}}</div>
            <div class="right">{{ item.ctime }}</div>
          </div>
          <div class="line">
            <div class="left">{{lang.EffectiveTime}}</div>
            <div class="right">{{ item.jsAt }}</div>
          </div>
        </div>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { CONF } from '@/assets/js/config'
  import {
    mapState
  } from 'vuex'
  export default {
    data() {
      return {
        page: 1,
        totalNum: 0,
        orderStatus: 0,
        recordList: [],
        loading: false,
        finished: false,
      }
    },
    activated() {
      this.page = 1
      this.recordList = []
      this.finished = false
    },
    beforeDestroy(){
    },
    computed: {
      ...mapState(['userInfo', 'lang'])

    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      onLoad() {
        // 异步更新数据
        // setTimeout 仅做示例，真实场景中一般为 ajax 请求
        setTimeout(() => {
          this.getRecord()
        }, 1000);
      },
      getRecord() {
        this.$xhrGet('/product/orderAi', {page: this.page,"status":this.orderStatus}).then(res => {
            if (res.err == 0) {
              // 加载状态结束
              this.loading = false;
              this.recordList = this.recordList.concat(res.data)
              this.totalNum = res.totalNum
              this.page +=1
              // 数据全部加载完成
              if (this.recordList.length >= this.totalNum) {
                this.finished = true;
              }
            }
        })
      },
      selectMenu(index){
        if (this.orderStatus == index){return}
        this.orderStatus = index
        this.recordList = []
        this.page = 1
        this.finished = false
      },
    }
  }
</script>
<style type="text/css"  scoped>
.orderAi{
  background: #000;
  height: 100vh;
  color: #fff;
}
.headers{
  font-size: 0.53333rem;
  font-weight: 600;
  display: flex;
  padding: 0.53333rem;
  justify-content: center;
  align-items: center;
}
.bodyoo{
  margin:0 20px;
  height: 80%;
  overflow: auto;
}
.new-features{
  padding: 30px 20px;
  background: #1a1a1a;
  border-radius: 20px;
  margin-bottom: 30px;
  position: relative;
}
.new-features:before {
  content: "";
  display: inline-block;
  background: #c2e22a;
  border-radius: 5px;
  width: 5px;
  height:24px;
  top: 20px;
  left: 0;
  position: absolute;
}
.new-features .title{
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 25px;
}
.new-features .line{
  display: flex;
  justify-content: space-between;
  margin-bottom: 22px;
}
.new-features .line .left {
  opacity: .3;
  font-size: 14px;

}
.menuss {
  margin-bottom: 15px;
  display: flex;
  justify-content: flex-start;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff4d;
}
.menuss .menu-active {
  background: #1a1a1a;
  color: #fff;
}
.menuss .menu {
  padding: 10px 17px;
  border-radius: 19px;
}
</style>